import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { addSpacesToTypeName } from 'src/app/pipes/split-enum-strings/add-spaces.pipe';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { systemLogAreaOptionSelectors } from '../state/system-logs-area-select-option.reducer';
import { SystemLogAreaOption } from '../system-logs-area-option.interface';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: SystemLogAreaSelectComponent,
        },
    ],
    selector: 'ndt-system-logs-area-select',
    templateUrl: './system-logs-area-select.component.html',
    standalone: false
})
export class SystemLogAreaSelectComponent extends LcsSingleSelectBase<SystemLogAreaOption> implements OnInit {
   systemLogAreas$: Observable<SystemLogAreaOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.systemLogAreas$ = this.store.pipe(
         select(systemLogAreaOptionSelectors.selectFilteredItems),
         map((items: Array<SystemLogAreaOption>) => {
            let filteredItems = items;

            return filteredItems;
         })
      );
   }

   displayWith(item: SystemLogAreaOption | null): string | null {
      return item ? (item.name ? addSpacesToTypeName(item.name) : null) : null;
   }

   trackBy(item: SystemLogAreaOption | null) {
      return item ? item.systemLogAreaId : null;
   }
}
